export default function ShieldTickBoldIcon() {
  return (
    <>
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M18.5398 4.12L13.0398 2.06C12.4698 1.85 11.5398 1.85 10.9698 2.06L5.4698 4.12C4.4098 4.52 3.5498 5.76 3.5498 6.89V14.99C3.5498 15.8 4.0798 16.87 4.7298 17.35L10.2298 21.46C11.1998 22.19 12.7898 22.19 13.7598 21.46L19.2598 17.35C19.9098 16.86 20.4398 15.8 20.4398 14.99V6.89C20.4498 5.76 19.5898 4.52 18.5398 4.12ZM15.4798 9.72L11.1798 14.02C11.0298 14.17 10.8398 14.24 10.6498 14.24C10.4598 14.24 10.2698 14.17 10.1198 14.02L8.5198 12.4C8.2298 12.11 8.2298 11.63 8.5198 11.34C8.8098 11.05 9.2898 11.05 9.5798 11.34L10.6598 12.42L14.4298 8.65C14.7198 8.36 15.1998 8.36 15.4898 8.65C15.7798 8.94 15.7798 9.43 15.4798 9.72Z"
          className="svg-fill"
        />
      </svg>
    </>
  );
}
